import styled from "styled-components";
import Card from "@mui/material/Card";
import { Box, Tooltip, TooltipProps } from '@mui/material';
import React from 'react';

export const captionRegular = (theme: any) =>`
  font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
  line-height: ${theme.uptimeDynamicAlignCenter?.deviceAndAcknowledgeCard?.lineHeightBrand ?? `${theme.uptimeLineHeights.desktop.lh3}px`};
  @media (min-width: 960px) {
    font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
    line-height: ${theme.uptimeDynamicAlignCenter?.deviceAndAcknowledgeCard?.lineHeightBrand ?? `${theme.uptimeLineHeights.desktop.lh3}px`};
  }
`;

export const captionRegularSemiBold = (theme: any) =>`
  font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
  line-height: ${theme.uptimeDynamicAlignCenter?.deviceAndAcknowledgeCard?.lineHeightConfigItem ?? `${theme.uptimeLineHeights.desktop.lh3}px`};
  font-weight: 600;
  @media (min-width: 960px) {
    font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
    line-height: ${theme.uptimeDynamicAlignCenter?.deviceAndAcknowledgeCard?.lineHeightConfigItem ?? `${theme.uptimeLineHeights.desktop.lh3}px`};
  }
`;

export const heading5 = (theme: any) =>`
  font-size: ${theme.uptimeFontSizes.mobile.fz6}px;
  line-height: ${theme.uptimeDynamicAlignCenter?.deviceAndAcknowledgeCard?.lineHeightName ?? 'initial'};
  font-weight: normal;
  @media (min-width: 960px) {
    font-size: ${theme.uptimeFontSizes.desktop.fz7}px;
  }
`;

export const max1lines = `
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const PCCardStyle = styled(Card)`
  ${({theme}) => `
    background-color: ${theme.uptimeColors.grayScales.white};
    color: ${theme.uptimeColors.grayScales.black};
    min-height: auto;
    width: 100%;
    max-height: 300px;
    height: 300px;
    border-radius: ${theme.uptimeSpace[5]}px !important;
    position: relative;
    .MuiCardHeader-root{
      padding: ${theme.uptimeSpace[6]}px ${theme.uptimeSpace[8]}px ${theme.uptimeSpace[0]}px;
    }
    .uptime-device-card-header {
      min-height: 32px;
    }
    .uptime-device-card-content {
      padding-top: ${theme.uptimeSpace[0]}px;
      padding-bottom: ${theme.uptimeSpace[4]}px;
      &-image {
        margin-bottom: ${theme.uptimeSpace[5]}px;
      }
      .uptime-device-card-configuration {
        padding-left: ${theme.uptimeSpace[0]}px;
        font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
        line-height: ${theme.uptimeSpace[9]}px;
        &-item-content,
        &-item-header {
          font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
        }
        .uptime-device-card-deviceBrand {
          ${captionRegular(theme)};
          color: ${theme.uptimeColors.grayScales.darkerGray};
          text-transform: uppercase;
          margin-bottom: 0;
        }
        .uptime-device-card-deviceName {
          ${heading5(theme)};
          
          margin-bottom: ${theme.uptimeSpace[2]}px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .uptime-device-card-configuration-item{        
          display: flex;
          align-items: center;
          justify-content: left;
          font-size: ${theme.uptimeFontSizes.desktop.fz1}px;
          flex-wrap: nowrap;        
          
          .initiate-chat-btn {
            border: 0;
            background-color: #fff;
            font-weight: 700;
            padding: 0 8px;
            cursor: pointer;
            text-decoration: underline;
            color: #414042 !important;
          }
          .uptime-device-card-configuration-item-header{
            ${captionRegularSemiBold(theme)};
            white-space: nowrap;
            margin-right: ${theme.uptimeSpace[2]}px;
          }
          .uptime-device-card-configuration-item-content{
            color: ${theme.uptimeColors.grayScales.darkerGray};
            word-break: break-all;
            ${max1lines};
            ${captionRegular(theme)};
          }
          .device-health-wrapper{
            display: flex;
            align-items: center;
          }
        }
      }
      .device-health{
        max-width: 238px;
      }
      .uptime-device-card-content-image {
        display: block;
        margin-top: ${theme.uptimeSpace[3]}px;
        .uptime-device-card-content-CardMedia{
          height: 113px;
          background-size: contain;
        }      
        .uptime-device-card-content-image-brand{
          color: ${theme.uptimeColors.grayScales.black};
          font-size: ${theme.uptimeFontSizes.desktop.fz7}px;
          padding-bottom: ${theme.uptimeSpace[5]}%;
          padding-left: ${theme.uptimeSpace[6]}px;
        }
      }
    }
    .uptime-device-card-footer{
      display: flex;
      flex-direction: row-reverse;
      position: absolute;
      bottom: 24px;
      right: 16px;
      .uptime-device-card-button{
        background: ${theme.uptimeColors.generalColors.button.primary.enabled};
        color: white;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        z-index: 0 !important;
        .add-icon{
          width: 30px;
          height: 30px;
        }
      }
    }
    .MuiTooltip-popperInteractive.MuiTooltip-popperArrow {
      & a {
        color: white !important;
    }
  }
`}`;

const CustomTooltip = ({ className, children, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }}>
    <Box sx={{ wordBreak: 'break-word' }}>{children}</Box>
  </Tooltip>
);
  
export const StyledTooltip = styled(CustomTooltip)(({ theme }) => ({
  '.MuiTooltip-tooltip': {
    marginTop: `${theme.uptimeSpace[3]}px !important`,
  },
}));